// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"a7f668ac","334":"795b29f5","453":"c06ab884","573":"b27967c3","895":"2dda2be7"}[chunkId] + ".chunk.js";
};